import { inject, Injectable } from '@angular/core';
import { AlertsSchedularCreateRequestDTO, AlertsSchedularDeleteRequestDTO, AlertsSchedularDTO, AlertsSchedularList, AlertsSchedularReadAllDTO, AlertsSchedularReadByIdRequestDTO, AlertsSchedularUpdateRequestDTO } from './schedulers.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AlertsSchedular_create, AlertsSchedular_delete, AlertsSchedular_readAll, AlertsSchedular_readAllPaginated, AlertsSchedular_readById, AlertsSchedular_update } from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class SchedulersService {

  constructor() { }

  http = inject(HttpClient)
  
  AlertsSchedular_create(data: AlertsSchedularCreateRequestDTO): Observable<AlertsSchedularDTO> {
      return this.http.post<AlertsSchedularDTO>(AlertsSchedular_create, data);
    }
  
    AlertsSchedular_update(data: AlertsSchedularUpdateRequestDTO): Observable<AlertsSchedularDTO> {
      return this.http.post<AlertsSchedularDTO>(AlertsSchedular_update, data);
    }
    AlertsSchedular_readById(data: AlertsSchedularReadByIdRequestDTO): Observable<AlertsSchedularDTO> {
      return this.http.post<AlertsSchedularDTO>(AlertsSchedular_readById, data);
    }
    AlertsSchedular_readAll(data:AlertsSchedularReadAllDTO): Observable<AlertsSchedularList> {
      return this.http.post<AlertsSchedularList>(AlertsSchedular_readAll,data);
    }
    AlertsSchedular_readAllPaginated(data: AlertsSchedularReadAllDTO): Observable<AlertsSchedularList> {
      return this.http.post<AlertsSchedularList>(AlertsSchedular_readAllPaginated, data);
    }
  
  
    AlertsSchedular_delete(data: AlertsSchedularDeleteRequestDTO): Observable<void> {
      return this.http.post<void>(AlertsSchedular_delete, data);
    }
}
